import {
  Box,
  Flex,
  Image,
  RatioContainer,
  Shimmer,
  MediaBox,
} from "@jewlr/storybook/core"
import React from "react"
import styled, { keyframes } from "styled-components"

const ImagesContainer = styled(Flex)`
  flex-wrap: wrap;
  margin-bottom: 35px;
  padding: 0 10px;
  ${({ theme }) => theme.mediaQueries.tablet`
    padding: 0;
  `}
`
const GridItem = styled.div`
  margin-bottom: 24px;
  padding: 0 5px;
  position: relative;
  text-align: center;
  width: 50%;
  ${({ theme }) => theme.mediaQueries.tablet`
    width: 33.333%;
    margin-bottom: 30px;
  `};
`

const shimmer = keyframes`
  from {
    background-position: -256px 0;
  }
  to {
    background-position: 256px 0;
  }
`

const StyledImage = styled(Image)`
  animation: ${shimmer} 1.5s forwards infinite;
  background: #f6f7f8;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  height: auto;
  max-height: 256px;
  max-width: 100%;
  overflow: hidden;
  ${({ theme }) => theme.mediaQueries.tablet`
    width: 100%;
    max-width: 256px;
  `}
`

const Shimmers = () => (
  <Box contain mb={3}>
    <Box px={2} py={4} textAlign="center">
      <Shimmer height="34px" mb="4px" mx="auto" width="200px" />
      <Shimmer height="20px" mx="auto" width="300px" />
    </Box>
    <Flex
      justifyContent="space-between"
      px={{ _: 2, tablet: 0 }}
      py={{ _: 10, tablet: 20 }}
    >
      <Flex justifyContent="flex-start">
        <Shimmer height={16} width={48} />
        <MediaBox greaterThanOrEqual="tablet">
          <Shimmer height={16} ml={6} width={56} />
          <Shimmer height={16} ml={4} width={56} />
          <Shimmer height={16} ml={4} width={56} />
        </MediaBox>
      </Flex>

      <Flex justifyContent="flex-start">
        <Shimmer height={16} width={48} />
        <Shimmer height={16} ml={{ _: 3, tablet: 6 }} width={56} />
      </Flex>
    </Flex>
    <Box pt={2}>
      <ImagesContainer>
        {[...Array(6)].map((img, i) => (
          <GridItem key={`placholder${i}`}>
            <RatioContainer
              pb={{ _: "100%", desktop: "256px", tablet: "256px" }}
            >
              <div>
                <StyledImage
                  alt="placeholder ring"
                  src={require(`images/collections/placeholder_masks/ring_${
                    (i % 6) + 1
                  }.svg`)}
                />
              </div>
            </RatioContainer>
          </GridItem>
        ))}
      </ImagesContainer>
    </Box>
  </Box>
)

Shimmers.propTypes = {}

export default Shimmers
